import type { SyncingState } from 'src/modules/syncing';

import { Actions } from '../../../../reducer';

export enum ErrorMessageType {
  Delete = 'Delete',
  Download = 'Download',
  Default = 'Default',
  Virus = 'Virus',
  Pending = 'Pending',
  SensitiveInformation = 'SensitiveInformation',
}

const actionToErrorMessageType: Record<string, ErrorMessageType> = {
  [Actions.RESUME_DELETE]: ErrorMessageType.Delete,
  [Actions.RESUME_GET_LINK]: ErrorMessageType.Download,
  [Actions.RESUME_UPDATE_DEFAULT]: ErrorMessageType.Default,
};

export const getErrorMessageType = ({
  action,
  resumeSyncState,
  hasSensitiveInfo,
  hasVirus,
  isPending,
}: {
  action?: string;
  resumeSyncState: SyncingState;
  hasSensitiveInfo: boolean;

  hasVirus: boolean;
  isPending: boolean;
}) => {
  if (hasSensitiveInfo) {
    return ErrorMessageType.SensitiveInformation;
  }
  if (
    hasVirus &&
    action !== Actions.RESUME_DELETE &&
    resumeSyncState !== 'ERROR'
  ) {
    return ErrorMessageType.Virus; // resumeErrors.hasVirus;
  }
  if (isPending) {
    return ErrorMessageType.Pending;
  }
  return action && resumeSyncState === 'ERROR'
    ? actionToErrorMessageType[action]
    : '';
};
